<template>
  <filter-groupings-expand-toggle v-bind="$attrs" :cache-key="cacheKey" />
  <filter-grouping
    v-if="checkboxFilters"
    title="Status"
    icon="edit_note"
    :cache-key="cacheKey"
    :grouping-id="groupingIds.statusFilterGroup"
    :has-filters="searchStore.hasFilters({ checkbox: ['status'] })"
    container-classes="routine-status"
  >
    <checkbox-filter
      :checkbox-filter="checkboxFilters.status"
      :tri-state="features.VIDEO_FILTERS"
      :show-title="false"
      @checkbox-change="triggerFiltering"
    />
  </filter-grouping>
  <filter-grouping
    v-if="dropdownFilters"
    title="Schedule"
    icon="calendar_month"
    :cache-key="cacheKey"
    :grouping-id="groupingIds.scheduleFilterGroup"
    :has-filters="searchStore.hasFilters({ dropdown: ['schedule'] })"
    container-classes="schedule"
  >
    <dropdown-filter
      v-if="features.VIDEO_FILTERS"
      :dropdown-filter="dropdownFilters.schedule"
      @dropdown-change="triggerFiltering"
    />
  </filter-grouping>
  <filter-grouping
    v-if="checkboxFilters && checkboxFilters.bodyfocus_ids"
    title="Body Focus"
    icon="accessibility_new"
    :cache-key="cacheKey"
    :grouping-id="groupingIds.bodyFocusFilterGroup"
    :has-filters="searchStore.hasFilters({ checkbox: ['bodyfocus_ids'] })"
    container-classes="bodyfocus"
  >
    <checkbox-filter
      :checkbox-filter="checkboxFilters.bodyfocus_ids"
      :tri-state="features.VIDEO_FILTERS"
      :toggle-all="true"
      :show-title="false"
      @checkbox-change="triggerFiltering"
    />
  </filter-grouping>
  <filter-grouping
    v-if="checkboxFilters && checkboxFilters.trainingtype_ids"
    title="Training Type"
    icon="directions_run"
    :cache-key="cacheKey"
    :grouping-id="groupingIds.trainingTypeFilterGroup"
    :has-filters="searchStore.hasFilters({ checkbox: ['trainingtype_ids'] })"
    container-classes="training-type"
  >
    <checkbox-filter
      :checkbox-filter="checkboxFilters.trainingtype_ids"
      :tri-state="features.VIDEO_FILTERS"
      :toggle-all="true"
      :show-title="false"
      @checkbox-change="triggerFiltering"
    />
  </filter-grouping>
  <filter-grouping
    v-if="checkboxFilters && checkboxFilters.equipment_ids"
    title="Equipment"
    icon="fitness_center"
    :cache-key="cacheKey"
    :grouping-id="groupingIds.equipmentFilterGroup"
    :has-filters="searchStore.hasFilters({ checkbox: ['equipment_ids'] })"
    container-classes="equipment"
  >
    <checkbox-filter
      :checkbox-filter="checkboxFilters.equipment_ids"
      :tri-state="features.VIDEO_FILTERS"
      :toggle-all="true"
      :show-title="false"
      @checkbox-change="triggerFiltering"
    />
  </filter-grouping>
  <filter-grouping
    v-if="checkboxFilters"
    title="Routine Options"
    icon="tune"
    :cache-key="cacheKey"
    :grouping-id="groupingIds.otherFilterGroup"
    :has-filters="
      searchStore.hasFilters({
        exclude: ['keywords', 'status', 'bodyfocus_ids', 'trainingtype_ids', 'equipment_ids'],
      })
    "
    container-classes="options"
  >
    <checkbox-filter
      :checkbox-filter="checkboxFilters.minutes"
      :tri-state="features.VIDEO_FILTERS"
      @checkbox-change="triggerFiltering"
    />
    <checkbox-filter
      :checkbox-filter="checkboxFilters.days_week"
      :tri-state="features.VIDEO_FILTERS"
      @checkbox-change="triggerFiltering"
    />
    <checkbox-filter
      :checkbox-filter="checkboxFilters.weeks"
      :tri-state="features.VIDEO_FILTERS"
      @checkbox-change="triggerFiltering"
    />
    <checkbox-filter
      :checkbox-filter="checkboxFilters.difficulty"
      :tri-state="features.VIDEO_FILTERS"
      @checkbox-change="triggerFiltering"
    />
  </filter-grouping>
</template>

<script setup lang="ts">
import { onBeforeMount } from 'vue'
import { useSearchFilter } from '@/composables/search-filter'
import { useSearchStore } from '@/stores/search'
import CheckboxFilter from '@/components/search/checkbox-filter.vue'
import FilterGrouping from '@/components/search/filter-grouping.vue'
import DropdownFilter from '@/components/search/dropdown-filter.vue'
import FilterGroupingsExpandToggle from '@/components/search/filter-groupings-expand-toggle.vue'

/** STATE **/
const searchStore = useSearchStore()

/** NON REACTIVE **/
// groupingIds and cacheKey use to persist expanded state to local storage
const groupingIds = {
  statusFilterGroup: 'statusFilterGroup',
  scheduleFilterGroup: 'scheduleFilterGroup',
  bodyFocusFilterGroup: 'bodyFocusFilterGroup',
  trainingTypeFilterGroup: 'trainingTypeFilterGroup',
  equipmentFilterGroup: 'equipmentFilterGroup',
  otherFilterGroup: 'otherFilterGroup',
}

// local storage cache key for which filters are expanded
const cacheKey = 'routine-filter-groupings-expanded-v1'

/** EMITS **/
const emit = defineEmits(['filter-update'])

/** COMPOSABLES **/
const {
  features,
  checkboxFilters,
  dropdownFilters,
  triggerFiltering,
  initFilterGroupingsExpandedCache,
} = useSearchFilter({ emit })

/** LIFECYCLE **/
onBeforeMount(() => {
  // init expanded state from local storage
  initFilterGroupingsExpandedCache({ cacheKey, groupingIds })
})
</script>
